module.exports = __webpack_public_path__ + "media/images/Merge2-blue-2cac8ad9139c021f084ad656330f7b38.svg";